import React, {useEffect, useRef} from "react";
import {connect} from "react-redux";
import {changeCursorSize, showCursorText} from "../../actions/CursorActions";
import {DEFAULT_CURSOR_SIZE} from "../../constants/cursorConstants";
import {useNavigate} from "react-router-dom";
import {isMobile, isTablet} from "react-device-detect";

function FilmBox(props) {
    const navigate = useNavigate();
    const inputRef = useRef()
    const [parallax, setParallax] = React.useState(100);

    useEffect(()=> {
        const offset = 0.8 * window.innerHeight;
        const height = 0.8 * window.innerHeight;

        const calculateParallax = () => {
            if (!inputRef.current) return;
            const startMark = inputRef.current.offsetTop - offset;
            const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
            const parallaxVal = ((1 - (winScroll - startMark) / height) * 100);
            setParallax(Math.max(0, Math.min(parallaxVal, 100)));
        };

        calculateParallax();

        window.addEventListener("scroll", calculateParallax);
        return () => {
            window.removeEventListener("scroll", calculateParallax);
        };
    },[]);

    return (
        <div ref={inputRef}
             className={'film-box'}
             onMouseEnter={() => {
                 props.dispatch(showCursorText(props.title))
             }}
             onMouseLeave={() => {
                props.dispatch(changeCursorSize(DEFAULT_CURSOR_SIZE))
             }}
             onClick={()=>{
                 props.dispatch(changeCursorSize(DEFAULT_CURSOR_SIZE))
                 navigate(props.title.replaceAll(" ","-").replace("/","—"))
             }}
        >
            <div
                 style={{
                     backgroundImage: `url("${props.thumbnail}")`,
                     backgroundPosition: `50% ${parallax}%`
                 }}>
            </div>
            {(isMobile || isTablet) && (<div>
                <h2>
                    {props.title}
                </h2>
                <div>
                    <div>

                    </div>
                </div>
            </div>)}
        </div>
    );
}

export default connect()(FilmBox);